
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Services() {
  const { t } = useTranslation();

  const services = [
    {
      icon: 'ri-file-text-line',
      title: t('service1Title'),
      description: t('service1Desc'),
      features: [
        t('service1Feature1'),
        t('service1Feature2'),
        t('service1Feature3'),
        t('service1Feature4'),
        t('service1Feature5'),
        t('service1Feature6')
      ],
      image: 'https://public.readdy.ai/ai/img_res/e92c27d6ffa8a89fa32dc343dc32360a.jpg'
    },
    {
      icon: 'ri-award-line',
      title: t('service2Title'),
      description: t('service2Desc'),
      features: [
        t('service2Feature1'),
        t('service2Feature2'),
        t('service2Feature3'),
        t('service2Feature4'),
        t('service2Feature5')
      ],
      image: 'https://readdy.ai/api/search-image?query=Professional%20certified%20translation%20documents%20with%20official%20stamps%20and%20seals%2C%20USCIS%20accepted%20paperwork%2C%20academic%20transcripts%20and%20medical%20records%20on%20clean%20desk%2C%20certification%20process%20for%20legal%20translation%20services%2C%20organized%20official%20documents%20with%20authentication%20marks&width=500&height=500&seq=certified-translation&orientation=squarish'
    },
    {
      icon: 'ri-mic-line',
      title: t('service3Title'),
      description: t('service3Desc'),
      features: [
        t('service3Feature1'),
        t('service3Feature2'),
        t('service3Feature3'),
        t('service3Feature4'),
        t('service3Feature5')
      ],
      image: 'https://readdy.ai/api/search-image?query=Professional%20courtroom%20or%20legal%20meeting%20room%20with%20microphone%20and%20interpretation%20equipment%2C%20formal%20legal%20setting%20for%20court%20interpretation%20services%2C%20modern%20legal%20environment%20with%20professional%20atmosphere&width=400&height=300&seq=court-interpretation&orientation=landscape'
    },
    {
      icon: 'ri-passport-line',
      title: t('service4Title'),
      description: t('service4Desc'),
      features: [
        t('service4Feature1'),
        t('service4Feature2'),
        t('service4Feature3'),
        t('service4Feature4'),
        t('service4Feature5')
      ],
      image: 'https://readdy.ai/api/search-image?query=Immigration%20documents%20including%20passport%2C%20birth%20certificate%2C%20marriage%20certificate%20and%20official%20papers%20spread%20on%20desk%2C%20professional%20document%20translation%20setup%20for%20immigration%20services%2C%20organized%20legal%20paperwork&width=400&height=300&seq=immigration-docs&orientation=landscape'
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-bold text-slate-800 mb-6">
              {t('servicesTitle')}
            </h1>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed">
              {t('servicesSubtitle')}
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-20">
            {services.map((service, index) => (
              <div key={index} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${index % 2 === 1 ? 'lg:grid-flow-col-dense' : ''}`}>
                <div className={index % 2 === 1 ? 'lg:col-start-2' : ''}>
                  <div className="w-16 h-16 bg-slate-700 rounded-lg flex items-center justify-center mb-6">
                    <i className={`${service.icon} text-2xl text-white w-8 h-8 flex items-center justify-center`}></i>
                  </div>
                  <h2 className="text-3xl font-bold text-slate-800 mb-4">
                    {service.title}
                  </h2>
                  <p className="text-lg text-slate-600 mb-6 leading-relaxed">
                    {service.description}
                  </p>
                  <ul className="space-y-2 mb-8">
                    {service.features.map((feature, featureIndex) => (
                      <li key={featureIndex} className="flex items-center text-slate-600">
                        <i className="ri-check-line text-teal-5

00 mr-3 w-5 h-5 flex items-center justify-center"></i>
                        {feature}
                      </li>
                    ))}
                  </ul>
                  <Link
                    to="/contact"
                    className="inline-flex items-center px-6 py-3 bg-slate-700 text-white font-semibold rounded-lg hover:bg-slate-800 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {t('getQuote')}
                    <i className="ri-arrow-right-line ml-2 w-4 h-4 flex items-center justify-center"></i>
                  </Link>
                </div>
                <div className={index % 2 === 1 ? 'lg:col-start-1' : ''}>
                  <img
                    src={service.image}
                    alt={service.title}
                    className="rounded-xl shadow-lg object-cover w-full h-96 object-top"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-4">
              {t('processTitle')}
            </h2>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto">
              {t('processSubtitle')}
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {[
              {
                step: '01',
                title: t('process1Title'),
                description: t('process1Desc')
              },
              {
                step: '02',
                title: t('process2Title'),
                description: t('process2Desc')
              },
              {
                step: '03',
                title: t('process3Title'),
                description: t('process3Desc')
              },
              {
                step: '04',
                title: t('process4Title'),
                description: t('process4Desc')
              }
            ].map((process, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-slate-700 text-white rounded-full flex items-center justify-center mx-auto mb-4 text-xl font-bold">
                  {process.step}
                </div>
                <h3 className="text-xl font-semibold text-slate-800 mb-3">
                  {process.title}
                </h3>
                <p className="text-slate-600">
                  {process.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-slate-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            {t('ctaTitle')}
          </h2>
          <p className="text-xl text-slate-300 mb-8 max-w-2xl mx-auto">
            {t('ctaSubtitle')}
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center px-8 py-4 bg-teal-5
            00 text-white font-semibold rounded-lg hover:bg-teal-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            {t('ctaButton')}
            <i className="ri-arrow-right-line ml-2 w-5 h-5 flex items-center justify-center"></i>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
